import "core-js/modules/es.array.filter.js";
import Vue from 'vue';
import Gikam from 'gikam';
export default function () {
  Vue.filter('backendI18nFilter', function (key) {
    return Gikam.propI18N(key);
  });
}